import FirebaseContext, { withFirebase } from "./context";
import Firebase from "./firebase";

import { onAuthStateChanged, updatePassword, updateProfile,updateEmail,reauthenticateWithCredential,EmailAuthProvider ,getAuth,signOut   } from "firebase/auth";

export default Firebase;

export { FirebaseContext, onAuthStateChanged, updateEmail ,updatePassword, updateProfile, reauthenticateWithCredential, EmailAuthProvider,getAuth, signOut, withFirebase };
